module.exports = __webpack_public_path__ + "static/media/awfext32_6052.27655373.ico";